<template>
  <v-snackbar :timeout="10000" :error="message.meta.error" :primary="message.meta.success" :info="message.meta.info" :warning="message.meta.warning" v-model="isVisible" multi-line>
    <v-icon v-if="message.meta.error" class="mr-2">error</v-icon>
    <v-icon v-else class="mr-2">info</v-icon>
    {{ message.message }}
    <v-btn flat @click.native="isVisible = false" icon v-tooltip:left="{ html: 'Inchide mesajul' }" class="ma-0">
      <v-icon>close</v-icon>
    </v-btn>
    <v-btn flat @click.native="clearAll" icon v-tooltip:left="{ html: 'Goleste mesageria.' }" class="ma-0">
      <v-icon>clear_all</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
  export default {
    props: {
      messages: {
        type: Array
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        fakeMessage: {
          message: '',
          meta: {
            error: false,
            success: false,
            info: false,
            warning: false
          }
        }
      }
    },
    computed: {
      isVisible: {
        get () {
          return this.visible
        },
        set (value) {
          this.$store.commit('toggleSnacks', value)
          if (!value) {
            setTimeout(() => {
              this.$store.commit('removeSnack')
              if (this.messages.length) {
                setTimeout(() => this.$store.commit('toggleSnacks', true), 500)
              }
            }, 500)
          }
        }
      },
      message () {
        return this.messages.length ? this.messages.slice(0, 1)[0] : this.fakeMessage
      }
    },
    methods: {
      clearAll () {
        this.$store.commit('clearMessages')
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Snackbar.vue?5f1f3f9a